import React from 'react';
import { connectSearchBox } from 'react-instantsearch-dom';
import styled from 'styled-components';
import { standardColours, visuallyHidden } from '../styles';
import { Svg } from './ui';
import searchIcon from '../images/search-icon.inline.svg';

const StyledSearchBox = styled.form`
  width: 460px;
`;

const StyledInner = styled.div`
  position: relative;
`;

const StyledLabel = styled.label`
  ${visuallyHidden()};
`;

const StyledInput = styled.input`
  padding: 10px 60px 10px 20px;
  height: 50px;
  width: 100%;
  background-color: ${standardColours.lightGrey};
  border: none;
`;

const StyledButton = styled.button`
  position: absolute;
  top: 50%;
  right: 10px;
  padding: 10px;
  background-color: ${standardColours.transparent};
  border: none;
  transform: translateY(-50%);
`;

const StyledIcon = styled(Svg)`
  position: relative;
  top: 3px;
  height: 18px;
  width: 18px;
`;

const StyledText = styled.span`
  ${visuallyHidden()};
`;

const SearchBox = ({ refine, currentRefinement, onFocus }) => (
  <StyledSearchBox>
    <StyledInner>
      <StyledLabel for="search-term">Search our ranges...</StyledLabel>
      <StyledInput
        type="search"
        id="search-term"
        placeholder="Search"
        onChange={e => refine(e.target.value)}
        value={currentRefinement}
        onFocus={onFocus}
      />
      <StyledButton>
        <StyledIcon image={searchIcon} />
        <StyledText>Search</StyledText>
      </StyledButton>
    </StyledInner>
  </StyledSearchBox>
);

export default connectSearchBox(SearchBox);
